import * as React from "react";
import Input from "../../Input-new/Input";

const RepresentationAgreement = ({isAgent, data, handleChangeInput, viewMode, deleted}) => {
    return (
        <div className="Listing-info">
            <div className="Listing-info_column">
                <Input
                    className="Listing-info_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="LISTED_DATE"
                    label="Date Listed"
                    value={data.LISTED_DATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Listing-info_column_item"
                    type="text"
                    valueType="number"
                    name="EXPIRATION_NO_OF_MONTHS"
                    label="# Of Months"
                    value={data.EXPIRATION_NO_OF_MONTHS}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Listing-info_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="EXPIRATION_DATE"
                    label="Listing Expiration Date"
                    value={data.EXPIRATION_DATE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Listing-info_column_item"
                    type="text"
                    valueType="percent"
                    name="SELLER_FEE_PERCENTAGE"
                    label="Fee Percentage"
                    value={data.SELLER_FEE_PERCENTAGE}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Listing-info_column_item"
                    disabled
                    type="text"
                    valueType="float"
                    name="TOTAL_FEE"
                    label="Total Fee - Auto"
                    value={data.TOTAL_FEE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
            </div>
        </div>
    );
};

export default RepresentationAgreement;
